export const convertEvent = (item) => {
  return {
    ...item,
    id: item._id,
    start: new Date(item.start),
    end: new Date(item.end),
  };
};
